module.exports = __webpack_public_path__ + "img/index-logo-2.279261da.png";